import { ARTIST_CATEGORY, ArtistCategory } from '@favid-inc/api';
import { Action } from 'core/generic';
import { request } from 'utils';
import { BEFORE_PROCESSING, Categorie, ERROR_FETCH_CATEGORIES, ON_FETCH_CATEGORIES } from './types';

const mapStringToCategories = (list: ArtistCategory[]) => {
  return list.sort().map((categorie, index): Categorie => ({ id: index, description: categorie }));
};

export const fetchCategories = async (dispatch: (action: Action) => void) => {
  dispatch({
    type: BEFORE_PROCESSING,
  });

  try {
    const response = await request.get(`/${ARTIST_CATEGORY}`);
    const list = mapStringToCategories(response.data);

    const payload = {
      list,
      total: response.data.length,
    };

    dispatch({
      type: ON_FETCH_CATEGORIES,
      payload,
    });
  } catch (error) {
    dispatch({
      type: ERROR_FETCH_CATEGORIES,
    });
  }
};

export const deleteCategorie = async (categorie: ArtistCategory, dispatch: (action: Action) => void) => {
  dispatch({
    type: BEFORE_PROCESSING,
  });
  try {
    const responseCategories = await request.get(`/${ARTIST_CATEGORY}`);
    const categories = responseCategories.data.filter((cat: string) => cat !== categorie);
    const response = await request.put(`/${ARTIST_CATEGORY}`, categories);
    const list = mapStringToCategories(response.data);

    const payload = {
      list,
      total: response.data.length,
    };

    dispatch({
      type: ON_FETCH_CATEGORIES,
      payload,
    });
  } catch (error) {
    dispatch({
      type: ERROR_FETCH_CATEGORIES,
    });
  }
};

export const updateCategories = async (categorie: ArtistCategory, dispatch: (action: Action) => void) => {
  dispatch({
    type: BEFORE_PROCESSING,
  });
  try {
    const responseCategories = await request.get(`/${ARTIST_CATEGORY}`);
    const categories = [...responseCategories.data, categorie];
    const response = await request.put(`/${ARTIST_CATEGORY}`, categories);
    const list = mapStringToCategories(response.data);

    const payload = {
      list,
      total: response.data.length,
    };

    dispatch({
      type: ON_FETCH_CATEGORIES,
      payload,
    });
  } catch (error) {
    dispatch({
      type: ERROR_FETCH_CATEGORIES,
    });
  }
};
